import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin, FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';

const Footer = () => {
    return (
        <footer className="bg-gray-900 text-white mt-16">
            <div className="container mx-auto px-4 py-12">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
                    {/* About Section */}
                    <div>
                        <h3 className="text-xl font-bold mb-4">About TFM Toys</h3>
                        <p className="text-gray-400 text-sm">
                            Premium toy store offering high-quality, safe, and educational toys for children of all ages.
                        </p>
                    </div>

                    {/* Quick Links */}
                    <div>
                        <h3 className="text-xl font-bold mb-4">Quick Links</h3>
                        <ul className="space-y-2">
                            <li><Link to="/" className="text-gray-400 hover:text-white transition">Home</Link></li>
                            <li><Link to="/products" className="text-gray-400 hover:text-white transition">Products</Link></li>
                            <li><Link to="/about" className="text-gray-400 hover:text-white transition">About Us</Link></li>
                            <li><Link to="/contact" className="text-gray-400 hover:text-white transition">Contact</Link></li>
                        </ul>
                    </div>

                    {/* Contact Info */}
                    <div>
                        <h3 className="text-xl font-bold mb-4">Contact Info</h3>
                        <ul className="space-y-2 text-gray-400 text-sm">
                            <li className="flex items-center gap-2">
                                <FaPhone className="text-purple-500" />
                                <span>+44 77479 57293</span>
                            </li>
                            <li className="flex items-center gap-2">
                                <FaEnvelope className="text-purple-500" />
                                <span>titanforgemetals@gmail.com</span>
                            </li>
                            <li className="flex items-center gap-2">
                                <FaMapMarkerAlt className="text-purple-500" />
                                <span>4, Speidhurst Road, Tunbridge Wells, TN4 ODP </span>
                            </li>
                        </ul>
                    </div>

                    {/* Newsletter */}
                    <div>
                        <h3 className="text-xl font-bold mb-4">Newsletter</h3>
                        <p className="text-gray-400 text-sm mb-3">Subscribe for exclusive offers!</p>
                        <div className="flex">
                            <input
                                type="email"
                                placeholder="Your email"
                                className="flex-1 px-3 py-2 text-gray-900 rounded-l-lg focus:outline-none"
                            />
                            <button className="bg-purple-600 px-4 py-2 rounded-r-lg hover:bg-purple-700 transition">
                                Subscribe
                            </button>
                        </div>
                    </div>
                </div>

                {/* Social Media & Copyright */}
                <div className="border-t border-gray-800 mt-8 pt-8">
                    <div className="flex flex-col md:flex-row justify-between items-center">
                        <div className="flex space-x-4 mb-4 md:mb-0">
                            <a href="#" className="bg-gray-800 p-2 rounded-full hover:bg-purple-600 transition">
                                <FaFacebook />
                            </a>
                            <a href="#" className="bg-gray-800 p-2 rounded-full hover:bg-purple-600 transition">
                                <FaTwitter />
                            </a>
                            <a href="#" className="bg-gray-800 p-2 rounded-full hover:bg-purple-600 transition">
                                <FaInstagram />
                            </a>
                            <a href="#" className="bg-gray-800 p-2 rounded-full hover:bg-purple-600 transition">
                                <FaLinkedin />
                            </a>
                        </div>
                        <p className="text-gray-400 text-sm">
                            &copy; 2024 TFM Toys. All rights reserved.
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;